import "./home-landing-work-area.component.scss";

export default {
    template: require('./home-landing-work-area.component.html'),
    controller: function (ServiceProvidersPublicApi, ErrorHandler) {
        'ngInject';

        const self = this;
        self.workAreas = [];

        const loadWorkAreas = (page, list) => {
            ServiceProvidersPublicApi.coverage({
                country: 'United States'
            }, function (result) {
                const list = appendServices(result);
                //removeDuplicate(list);
                self.workAreas = sortWorkArea(list);
            }, function (error) {
                ErrorHandler.onError(error);
            });
        }

        const appendServices = (data) => {
            let list = [];
            data.forEach(area => area.cities.forEach(city => list.push({
                part1: city,
                part2: area.district,
                link: '/our-coverage?address=' + city + ',' + area.district
            })));
            return list;
        }

        const sortWorkArea = (list) => {
            list.sort((e1, e2) => {
                if (e1.part1 > e2.part1) {
                    return 1;
                } else if (e1.part1 < e2.part1) {
                    return -1;
                }
                return 0;
            });

            return list;
        }

        loadWorkAreas(0)
    }
};
